import Evaporate from 'evaporate';
import config from '../config';

export const EPISODE_LEVEL = 'episodeLevel';

export const INTRO_OUTRO_MAP = {
  publicIntro: 'publicIntro',
  publicOutro: 'publicOutro',
  privateIntro: 'privateIntro',
  privateOutro: 'privateOutro',
};

const _formatShowOrEpisodeLevelIntroOutroFileName = (prefix, fileName) => {
  const prefixArr = prefix.split('-');
  const uploadTypeInPrefix = prefixArr[prefixArr.length - 1];
  const isEpisodeUpload = INTRO_OUTRO_MAP[uploadTypeInPrefix];

  const date = new Date().getTime();
  const identifier = `${date}-${crypto.randomUUID()}`;

  let currentPrefix = `${prefix}/${identifier}`;

  if (isEpisodeUpload) {
    currentPrefix = prefix.replace(EPISODE_LEVEL, identifier);
  }

  const extension = fileName.slice(fileName.lastIndexOf('.'), fileName.length);
  const name = `${currentPrefix}${extension}`;

  return name;
};

const initializeUploader = function (bucket, maxFileSize = null, progressInterval = 300) {
  return Evaporate.create({
    signerUrl: config.baseUrl + '/api/signv4_auth',
    aws_key: config.awsUploadAccessKeyId,
    awsRegion: config.awsRegion,
    bucket: bucket || config.s3Bucket,
    awsSignatureVersion: '4',
    computeContentMd5: true,
    logging: false, // verbosity
    maxFileSize: maxFileSize,
    progressIntervalMS: progressInterval, //the frequency (in milliseconds) at which progress events are dispatched
    cryptoMd5Method: function (data) {
      return window.AWS.util.crypto.md5(data, 'base64');
    },
    cryptoHexEncodedHash256: function (data) {
      return window.AWS.util.crypto.sha256(data, 'hex');
    },
  });
};

const upload = function (_e_, file, fileName, prefix, onProgress, handleUploadSuccess) {
  const name = _formatShowOrEpisodeLevelIntroOutroFileName(prefix, fileName);

  return _e_
    .add({
      name,
      file,
      xAmzHeadersAtInitiate: {
        'Content-Type': file.type,
        'x-amz-acl': 'public-read',
      },
      progress: function (progress) {
        if (!onProgress) {
          return;
        }
        onProgress(progress);
      },
    })
    .then((s3Key) => {
      if (!handleUploadSuccess) {
        return;
      }

      const fileUrl = `//s3.amazonaws.com/${config.s3Bucket}/${s3Key}`;

      if (!(file.type || '').includes('audio')) {
        return [fileUrl];
      }
      return new Promise(function (resolve, reject) {
        const au = document.createElement('audio');
        au.addEventListener(
          'loadedmetadata',
          function () {
            resolve([fileUrl, au.duration]);
          },
          false
        );
        au.addEventListener('error', function (error) {
          reject(error);
        });
        au.src = fileUrl;
      });
    })
    .then((result) => {
      const [fileUrl, duration] = result;
      handleUploadSuccess({
        s3: {
          filename: fileUrl.slice(fileUrl.lastIndexOf('/') + 1, fileUrl.length),
          filetype: file.type,
          originalname: '',
          size: file.size,
          url: fileUrl,
        },
        duration: duration,
      });
    });
};

export default { initializeUploader, upload };
